export const EU_REGISTRATION_PARAMETER_NAMES = [
  'IOSSRegNo',
  'IsIntermediaryAppointed',
  'OSSNonUnionRegNo',
  'OSSRegNo',
] as const

export type EuRegistrationParameterName =
  (typeof EU_REGISTRATION_PARAMETER_NAMES)[number]

export type EuRegistrationNumberName = Exclude<
  EuRegistrationParameterName,
  'IsIntermediaryAppointed'
>

export interface EuRegistrationParameter {
  isSet: boolean
  /** Avalara's raw value; "true"/"false" for IsIntermediaryAppointed */
  value: string | null
}

export type CompanyEuRegistration = Record<
  EuRegistrationParameterName,
  EuRegistrationParameter
>

export type ReadState = 'loading' | 'loaded' | 'error'
